// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__F1epW","isDisabled":"IconButton_isDisabled__b06G9","sizeS":"IconButton_sizeS__r7X3s","sizeM":"IconButton_sizeM___WsSh","icon":"IconButton_icon__f_rZ9"};